import { JobDtoType } from '../../../../../../domain/jobs';
import { withViewModel } from '../../../../../../infrastructure/components/with-view-model';
import { AttendeeBulkUpdateFormViewModel } from './attendee-bulk-update-form.viewmodel';
import { AttendeeBulkUpdateFormPresentation } from './attendee-bulk-update-form-presentation';

interface IMeetingFormContainerProps {
    onUpdateBulkList?: () => void;
    attendeeIds: number[];
    saveBulkCompletedCallback?: (attendeesToUpdate: JobDtoType) => void;
}

const AttendeeBulkUpdateFormContainer = withViewModel(AttendeeBulkUpdateFormPresentation, (props: IMeetingFormContainerProps) => {
    const attendeeBulkUpdateFormVM = new AttendeeBulkUpdateFormViewModel(
        props.onUpdateBulkList,
        props.attendeeIds,
        props.saveBulkCompletedCallback,
    );
    return attendeeBulkUpdateFormVM;
});

export { AttendeeBulkUpdateFormContainer as AttendeeBulkUpdateForm };
